import './styles.scss';

export const Loader = ({ variant, className }) => {
  return <div className={`loader loader--${variant} ${className}`}/>;
}